const jalaali = require('jalaali-js');

export function jalaliToUnixTimestamp(jalaliDateStr) {
    // Split the input date string to extract year, month, and day
    const [jy, jm, jd] = jalaliDateStr.split('/').map(Number);

    // Convert Jalali date to Gregorian date
    const { gy, gm, gd } = jalaali.toGregorian(jy, jm, jd);

    // Create a Date object for the Gregorian date
    const gregorianDate = new Date(gy, gm - 1, gd); // Month is zero-based

    // Convert Gregorian date to Unix timestamp (in seconds)
    const unixTimestamp = Math.floor(gregorianDate.getTime() / 1000);

    return unixTimestamp;
}